import React from 'react';
import {assert} from 'assert-ts';
import {Layout} from 'components/layout';
import {Thesaurus} from 'components/thesaurus';
import {useThesaurusEditStateContext} from '../contexts';

export const TopLevels: React.FC = () => {
  const {
    thesaurus,
    getDisplayCode,
    gotoCategory,
    categoryId,
    thesaurusEditValue,
  } = useThesaurusEditStateContext();

  assert(
    thesaurus.children,
    'ThesaurusTopLevels: children expected',
    thesaurus,
  );

  return (
    <Layout flex={1}>
      <Thesaurus
        onlyTopLevel
        thesaurusValue={thesaurusEditValue}
        getDisplayCode={getDisplayCode}
        data={thesaurus.children ?? []}
        focusedNodeId={categoryId}
        onSelectedItemsChange={(_, nodeIds: string | string[]) => {
          if (typeof nodeIds === 'string') {
            gotoCategory(nodeIds, nodeIds);
          }
        }}
      />
    </Layout>
  );
};
